import { Component, Element, h, Host, Prop } from "@stencil/core";
import { StzhLocaleComponent } from "../../index";

const CLASS_EXTERNAL_LINK = "stzh-richtext__external-link";
const CLASS_EXTERNAL_ICON_WRAPPER = "stzh-richtext__external-icon-wrapper";
const CLASS_EXTERNAL_ICON = "stzh-richtext__external-icon";
const CLASS_EXTERNAL_VHIDDEN = "stzh-richtext__external-vhidden";

/**
 * @slot - Text content that should be styled
 */
@Component({
  tag: "stzh-richtext",
  styleUrl: "stzh-richtext.scss",
  scoped: true,
})
export class StzhRichtext {
  /** Translation strings */
  @Prop() localization: StzhLocaleComponent;

  /** Whether first top margin of first child should be set to 0. */
  @Prop({ reflect: true }) removeFirstMargin: boolean;

  /** Whether last bottom margin of last child should be set to 0. */
  @Prop({ reflect: true }) removeLastMargin: boolean;

  /** Selector to recognize external link and attach an icon */
  @Prop() externalLinkSelector: string = 'a[rel*="external"], a.external, a.extern';

  /** Icon used for marking external links */
  @Prop() externalLinkIcon: string = "external-link";

  @Element() element: HTMLStzhRichtextElement;

  private externalLinks: HTMLElement[];

  private addExternalLinkIcons() {
    this.externalLinks.forEach(externalLink => {
      externalLink.classList.add(CLASS_EXTERNAL_LINK);

      // Check if screenreaderText already exists
      if (!externalLink.querySelector(`.${CLASS_EXTERNAL_VHIDDEN}`)) {
        const screenreaderText = document.createElement("span");
        screenreaderText.classList.add(CLASS_EXTERNAL_VHIDDEN);
        screenreaderText.innerText = this.localization.$globals.externalLinkLabel;
        externalLink.prepend(screenreaderText);
      }

      // Check if iconWrapper already exists
      if (!externalLink.querySelector(`.${CLASS_EXTERNAL_ICON_WRAPPER}`)) {
        const iconWrapper = document.createElement("span");
        iconWrapper.classList.add(CLASS_EXTERNAL_ICON_WRAPPER);

        const icon = document.createElement("stzh-icon");
        icon.classList.add(CLASS_EXTERNAL_ICON);
        icon.name = this.externalLinkIcon;
        iconWrapper.appendChild(icon);

        externalLink.appendChild(iconWrapper);
      }
    });
  }

  async componentWillLoad() {
    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "richtext");
    }
  }

  componentDidRender() {
    this.externalLinks = Array.from(this.element.querySelectorAll(this.externalLinkSelector));
    if (this.externalLinks && this.externalLinks.length > 0) {
      this.addExternalLinkIcons();
    }
  }

  render() {
    const classes = {
      "stzh-richtext": true,
    };

    return (
      <Host
        has-hidden-first-margin={typeof this.removeFirstMargin === "boolean" ? this.removeFirstMargin : true}
        has-hidden-last-margin={typeof this.removeLastMargin === "boolean" ? this.removeLastMargin : true}
      >
        <div class={classes}>
          <div class="stzh-richtext__text">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
